export enum StageType {
  DOCUMENT = 'DOCUMENT',
  PROCEDURE = 'PROCEDURE'
}

export const StageTypeTranslation = {
  [StageType.DOCUMENT]: 'Wniosek',
  [StageType.PROCEDURE]: 'Procedura'
};

export const StageTypeList = [
  { value: StageType.PROCEDURE, text: StageTypeTranslation[StageType.PROCEDURE] },
  { value: StageType.DOCUMENT, text: StageTypeTranslation[StageType.DOCUMENT] }
];
